/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  
  // Manually handle Klaviyo BIS toggle due to theme issues with the default trigger.
  console.log('ayoo')
  const triggerElement = document.querySelector('.klaviyo-bis-trigger');
  console.log(triggerElement)
  
  if (triggerElement) {
    const checkDisplayAndToggleClass = () => {
      const displayValue = getComputedStyle(triggerElement).display;
      
      if (displayValue !== 'none') {
        triggerElement.classList.add('visible');
      } else {
        triggerElement.classList.remove('visible');
      }
    };

    checkDisplayAndToggleClass();
    
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        console.log(mutation)
        if (mutation.attributeName === 'style') {
          checkDisplayAndToggleClass();
        }
      });
    });
  
    const config = { attributes: true, attributeFilter: ['style'] };
  
    observer.observe(triggerElement, config);
  }




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
